<script setup lang="ts">
import { IconMail } from '@tabler/icons-vue'
const themeStore = useThemeStore()
const { theme } = storeToRefs(themeStore)
const APP_NAME = import.meta.env.VITE_APP_NAME
const { t } = useI18n()
const email = ref(null)
const loading = ref(false)
async function forgotPassword(e) {
  e.preventDefault()
  errors.value = null
  sent.value = null
  loading.value = true
  const data = await fetchForgotPassword()
  loading.value = false
}

const sent = ref(null)
const errors = ref(null)

async function fetchForgotPassword() {
  const url = '/api/v1/forgot-password'
  const body = {
    email: email.value
  }
  const { data, promise, status } = useFetch(url, body, 'POST')
  await promise
  if (status.value === 422) {
    errors.value = data.value.message
  } else {
    sent.value = true
  }
}
</script>

<template>
  <div class="bg-light min-vh-100 d-flex flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol :xs="12" :md="12" :lg="6" :xl="4">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm @submit="e => forgotPassword(e)">
                  <CImage
                    v-if="theme === 'dark'"
                    fluid
                    src="/logo-bmotion-blanco-sm.png"
                    style="max-width: 100px; width: 50%; margin-left: -8px; margin-bottom: 4px"
                  />
                  <CImage
                    v-if="theme === 'light'"
                    fluid
                    src="/logo-bmotion-negro-sm.png"
                    style="max-width: 100px; width: 50%; margin-left: -8px; margin-bottom: 4px"
                  />
                  <h4>
                    <strong>{{ APP_NAME }}</strong>
                  </h4>
                  <p class="text-medium-emphasis">
                    {{ t('Enter your email and we will send you an email to begin the recovery process') }}
                  </p>
                  <CAlert v-if="sent" color="success">
                    <ul class="mb-0">
                      <li>
                        {{ t('We sent you an email with instructions') }}
                      </li>
                    </ul>
                  </CAlert>
                  <CAlert v-if="errors" color="danger">
                    <ul class="mb-0">
                      <template v-for="(error, index) in errors" :key="index">
                        <li v-for="(message, indexM) in error" :key="indexM">
                          {{ t(message) }}
                        </li>
                      </template>
                    </ul>
                  </CAlert>

                  <CInputGroup class="mb-3">
                    <CInputGroupText>
                      <IconMail stroke-width="1" />
                    </CInputGroupText>
                    <CFormInput :placeholder="t('E-mail')" v-model="email" />
                  </CInputGroup>
                  <CRow class="mb-4">
                    <CCol :xs="12" class="text-left">
                      <router-link to="/login">{{ t('Go back') }}</router-link>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol :xs="12" class="d-flex justify-content-end">
                      <CLoadingButton color="primary" type="submit" class="px-4" :loading="loading" :disabled="loading">
                        {{ t('Send') }}
                      </CLoadingButton>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <div class="g-recaptcha" data-sitekey="your_site_key"></div>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<style lang="scss" scoped></style>
